/**
 * Collection ranking badges only (best-selling).
 * Rank continues across paginated pages:
 *   rank = paginate.current_offset + index_on_page + 1
 */
(function () {
  function isBestSelling(root) {
    var params = new URLSearchParams(window.location.search);
    var sortBy = params.get('sort_by');
    if (sortBy === 'best-selling') return true;
    if (sortBy && sortBy !== 'best-selling') return false;
    return !!(root && root.getAttribute('data-ranking-active') === 'true');
  }

  function rankOffset(root) {
    var attr = root.getAttribute('data-rank-offset');
    if (attr != null && attr !== '') {
      var fromAttr = parseInt(attr, 10);
      if (!isNaN(fromAttr) && fromAttr >= 0) return fromAttr;
    }

    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('page') || '1', 10);
    if (isNaN(page) || page < 1) page = 1;

    var perPage = parseInt(root.getAttribute('data-products-per-page') || '', 10);
    if (isNaN(perPage) || perPage < 1) {
      // Last resort: count cards on page 1-sized grids only (unreliable on short last page).
      var grid = root.querySelector('#product-grid');
      perPage = grid ? grid.children.length : 0;
    }
    if (perPage < 1) return 0;
    return (page - 1) * perPage;
  }

  function applyRankBadges(root) {
    root.querySelectorAll('.sk-rank-badge').forEach(function (el) {
      el.remove();
    });

    if (!isBestSelling(root)) return;

    var offset = rankOffset(root);
    var cards = root.querySelectorAll('#product-grid .card-wrapper');
    cards.forEach(function (card, index) {
      var rank = offset + index + 1;
      var badge = document.createElement('div');
      badge.className =
        'sk-rank-badge ' +
        (rank <= 3 ? 'sk-rank-badge--' + rank : 'sk-rank-badge--default');
      badge.textContent = String(rank);
      badge.setAttribute('aria-hidden', 'true');

      var media =
        card.querySelector('.card__media') ||
        card.querySelector('.card__inner') ||
        card;
      if (window.getComputedStyle(media).position === 'static') {
        media.style.position = 'relative';
      }
      media.appendChild(badge);
    });
  }

  function refresh() {
    var root = document.querySelector('[data-collection-ranking]');
    if (!root) {
      var collection = document.querySelector('#ProductGridContainer .collection');
      if (collection) {
        collection.setAttribute('data-collection-ranking', '');
        root = collection;
      }
    }
    if (!root) return;

    root.setAttribute(
      'data-ranking-active',
      isBestSelling(root) ? 'true' : 'false'
    );
    applyRankBadges(root);
  }

  document.addEventListener('DOMContentLoaded', refresh);

  var lastUrl = location.href;
  var lastGridSignature = '';
  var debounceTimer = null;

  function gridSignature() {
    var grid = document.getElementById('product-grid');
    if (!grid) return '';
    var root = document.querySelector('[data-collection-ranking]');
    var offset = root ? root.getAttribute('data-rank-offset') || '' : '';
    return (
      location.href +
      '|' +
      grid.children.length +
      '|' +
      (grid.dataset.id || '') +
      '|off=' +
      offset
    );
  }

  function scheduleRefresh(force) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var sig = gridSignature();
      if (!force && sig === lastGridSignature) return;
      lastGridSignature = sig;
      refresh();
    }, 150);
  }

  var observer = new MutationObserver(function () {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      lastGridSignature = '';
      setTimeout(function () {
        scheduleRefresh(true);
      }, 300);
      return;
    }
    scheduleRefresh(false);
  });

  observer.observe(document.getElementById('MainContent') || document.body, {
    subtree: true,
    childList: true,
  });
})();
